<template>
  <div>
    <button
      type="button"
      :class="[
        'btn btnclass smallerfontsize mr-3',
        calculateSelectedClass
      ]"
      @click="form.sites.showSiteModal = true"
    >
      Site
    </button>
    <b-modal
      v-model="form.sites.showSiteModal"
      :no-close-on-backdrop="true"
      size="sm"
      title="Site"
      @shown="popupIsShown"
      @hide="popupIsHidden"
      @ok="saveSite"
    >
      <b-form-group>
        <b-form-checkbox
          v-model="allIsSelected"
          class="columncheckbox centerlabelandformgroup"
          @change="selectAll"
        >
          {{ allIsSelected ? "Deselect all" : "Choose all" }}
        </b-form-checkbox>
        <b-form-checkbox-group
          v-model="form.sites.selected"
          :options="form.sites.options"
          stacked
          class="columndd centerlabelandformgroup"
        />
      </b-form-group>
      <template #modal-footer="{ cancel, ok }">
        <b-button
          size="sm"
          variant="outline-secondary"
          @click="cancel()"
        >
          Cancel
        </b-button>
        <b-button
          size="sm"
          variant="primary"
          @click="ok()"
        >
          Save
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>

export default {
  name: 'SiteModal',
  props: {
    form: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      allIsSelected: false,
    }
  },
  computed: {
    calculateSelectedClass() {    
      return this.$store.getters[this.form.sites.apiBodyGetter].site_id.length > 0 ? 'selected' : '' 
    }
  },
  watch: {
    form: {
      handler(form) {
        if(form.sites.options.length === form.sites.selected.length)
          this.allIsSelected = true;
        else
          this.allIsSelected = false;
      }, deep: true
    },
  },
  methods: {
    selectAll(checked) {
      this.form.sites.selected = checked ? this.form.sites.options.map(a => a.value) : [];
    },
    popupIsShown(){
        document.addEventListener("keyup", this.onKeyUp);
        let apiBody = this.$store.getters[this.form.sites.apiBodyGetter];
        this.form.sites.selected = [...apiBody.site_id]
    },
    popupIsHidden(){
        document.removeEventListener("keyup", this.onKeyUp);
    },
    onKeyUp(event) {
      if (event.key === "Enter" && this.form.sites.showSiteModal) {
        this.form.sites.showSiteModal = false;
        this.saveSite()
      }
    },
    saveSite(){
      let payload = { 
        ...this.$store.getters[this.form.sites.apiBodyGetter],
        site_id: this.form.sites.selected
      }
      this.$store.commit(
        this.form.sites.apiBodySetter,
        payload,
      );
    }
  }
}
</script>
<style scoped>
>>> .custom-control.custom-checkbox {
    display: flex;
}
>>> .custom-control-label {
    display: flex;
    align-items: center;
}
.centerlabelandformgroup {
  width: 9rem;
  margin-left: 1rem;
}
</style>